import { combineReducers } from 'redux';

import directMerchantsIndex from './DirectMerchants/DirectMerchantsIndex/reducer';
import directMerchantsShow from './DirectMerchants/DirectMerchantsShow/reducer';
import merchantTransactions from './MerchantTransaction/reducer';
import merchantRegistrations from './MerchantRegistrations/reducer';

const directMerchants = combineReducers({
  index: directMerchantsIndex,
  show: directMerchantsShow
});

export default combineReducers({
  directMerchants,
  merchantTransactions,
  merchantRegistrations
});
